export default __webpack_public_path__ + "_/images/app/ios/ios-ru-2-46914ca68f961263c0113c3ff50bbd1687fcafe244478e642691f3b85f6f6d46.png";